/**
 * @desc 库容使用率分页查询
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.PositionStorageCapacityRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/warehousePosition/positionCapacityUtilizationPage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
